import * as React from 'react';
import { useCallback } from 'react';
import { Header3Text, Icon, IconSize, IconType, SmallBodyText } from 'ui-toolkit';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import { UploadDocument } from './upload/UploadDocument';
import { useDocumentsContext } from './DocumentsProvider';
import { v4 as uuidv4 } from 'uuid';

const Grid = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
`;

const StyledDropzoneArea = styled.div`
  align-items: center;
  border: dashed 1px ${(props) => props.theme.colors.primary};
  border-radius: ${(props) => props.theme.spacing.spacing5};
  display: flex;
  justify-content: center;
  padding: ${(props) => props.theme.spacing.spacing5};
`;

const SecondaryMessage = styled(SmallBodyText)`
  color: ${(props) => props.theme.colors.purple};
`;

interface IUploadsDocumentControllerProps {
  message?: string;
}

export const UploadsDocumentController: React.FC<IUploadsDocumentControllerProps> = ({ message }) => {
  const [
    {
      upload: { documents, orderID, creatableDocumentCategories },
      shared: { documentCategories },
    },
    dispatch,
  ] = useDocumentsContext();
  const onDrop = useCallback(
    (files: File[]) => {
      const uploadDocuments = files.map((file) => ({
        file,
        id: uuidv4(),
        order_id: orderID,
        category: undefined,
        isRepeatable: true,
      }));
      dispatch({
        type: 'SetUploadDocuments',
        payload: uploadDocuments,
      });

      if (creatableDocumentCategories && creatableDocumentCategories.length === 1) {
        uploadDocuments.forEach((u) =>
          dispatch({
            type: 'SetUploadDocumentCategory',
            payload: { id: u.id, category: creatableDocumentCategories[0] },
          })
        );
      }
    },
    [dispatch, orderID, creatableDocumentCategories]
  );
  const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: false });
  return (
    <Grid>
      <div {...getRootProps({ style: { display: documents.length ? 'none' : undefined } })}>
        <input {...getInputProps()} />
        <StyledDropzoneArea>
          <Icon type={IconType.Upload} size={IconSize.Large} />
          <div>
            <Header3Text>Drag & Drop or click to browse</Header3Text>
            {message && <SecondaryMessage>{message}</SecondaryMessage>}
          </div>
        </StyledDropzoneArea>
      </div>
      {documents.map((document) => (
        <UploadDocument
          key={document.file.name}
          document={document}
          documentCategories={creatableDocumentCategories || documentCategories}
        />
      ))}
    </Grid>
  );
};
